import(/* webpackMode: "eager" */ "/var/www/html/prod/src/app/[locale]/error.tsx")